import {
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { HlmIconComponent } from '@helipagos-ng/ui-icon-helm';
import { lucideBell, lucideMenu, lucideX } from '@ng-icons/lucide';
import {
  HlmAvatarImageDirective,
  HlmAvatarComponent,
  HlmAvatarFallbackDirective,
} from '@helipagos-ng/ui-avatar-helm';
import {
  HlmMenuBarComponent,
  HlmMenuBarItemDirective,
  HlmMenuComponent,
  HlmMenuGroupComponent,
  HlmMenuItemDirective,
} from '@helipagos-ng/ui-menu-helm';
import { BrnMenuTriggerDirective } from '@spartan-ng/ui-menu-brain';
import { UserStoreService } from '@hp-core/services/user-store.service';
import { AuthService } from '@helipagos/auth';
import { UpperCasePipe } from '@angular/common';
@Component({
  selector: 'core-header',
  standalone: true,
  imports: [

    HlmIconComponent,
    HlmAvatarImageDirective,
    HlmAvatarComponent,
    HlmAvatarFallbackDirective,
    HlmMenuComponent,
    HlmMenuItemDirective,
    HlmMenuBarItemDirective,
    HlmMenuBarComponent,
    BrnMenuTriggerDirective,
    HlmMenuGroupComponent
],
  providers: [provideIcons({ lucideBell, lucideMenu, lucideX })],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  menuOpen = false;
  private readonly _userStore = inject(UserStoreService);
  private readonly _authService = inject(AuthService);
  client = signal<string>('');
  role = signal<string>('');
  username = signal<string>('');

  @Output() menuToggled = new EventEmitter<boolean>();

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    this.menuToggled.emit(this.menuOpen);
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  logOffTheWeb(): void {
    this._authService.logOff();
  }

  ngOnInit() {
    this._userStore.getClient().subscribe((data: any) => {
      this.client.set(data ?? '');
    });
    this._userStore.getRole().subscribe((data: any) => {
      this.role.set(data ?? '');
    });

    this._userStore.getUsername().subscribe((data: any) => {
      this.username.set(data ?? '');
    });
  }
}
